import { memo } from 'react';
import { cn, TableListItem, TableListItemProps } from '@page/ui';

interface TableListFieldItemProps extends TableListItemProps {
  bold?: boolean;
  truncateLabel?: boolean;
}

const TableListFieldItemBase = ({
  children,
  bold = false,
  truncateLabel = true,
  labelClassName,
  valueContainerClassName,
  ...rest
}: TableListFieldItemProps) => {
  return (
    <TableListItem
      labelClassName={cn(
        'w-[296px] min-w-[296px]',
        {
          truncate: truncateLabel,
        },
        labelClassName,
      )}
      valueContainerClassName={cn(
        {
          'font-medium': bold,
        },
        valueContainerClassName,
      )}
      {...rest}
    >
      {children}
    </TableListItem>
  );
};

export const TableListFieldItem = memo(TableListFieldItemBase);
